import React, { Component } from 'react'
import qs from 'qs'
import searchIcon from './images/search.svg'
import Start from './Pages/Start'
import SubdomainPlans from './Pages/SubdomainPlans'
import WildcardPlans from './Pages/WildcardPlans';
import PopularPlans from './Pages/PopularPlans';
import PremiumPlans from './Pages/PremiumPlans';
import PersonalPlans from './Pages/PersonalPlans';
import AcceptingPaymentPlans from './Pages/AcceptingPaymentPlans';
import PersonalSecurePlans from './Pages/PersonalSecurePlans';
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import {ADMIN_AJAX_URL,getSiteAxios} from '../../../utilities/function/axios'

export const SSL_SELECTOR_CLASSNAME = "of-ssl-selector-connector";
export class SSLSelectorConnector extends Component {
  constructor(props){
    super();
    const {pids} = props
    this.state = {
      page: 'Start',
      mode: null,
      data: null
    }
    const getPIDSarray = () => {
      let arr = pids.split(".")
      if(arr && arr.length >0 && Array.isArray(arr)){
        return arr.map(function(item) {
          return item.trim();
        });
      }
      return null
    }
    this.pids = getPIDSarray()
    this.resetAll = this.resetAll.bind(this);
  }

  componentDidMount(){
    getSiteAxios().post(ADMIN_AJAX_URL,qs.stringify({
      action: 'get_ssl_config'
    }))
      .then((response)=>{
        const {data} = response;
        this.setState({
          ...this.state,
          data
        })
      })
      .catch((error)=>{
        console.log(error);
      })
  }

  resetAll(e){
    e.preventDefault();
    this.setState({
      page: 'Start',
      mode: null
    })
  }

  render() {
    const {container} = this.props
    const PageRouter = () => {
      const {page,data} = this.state;
      if(data){
        if(page==='Start') {
          return (
            <Start parent={this} />
          )
        }
        else if(page==='SubdomainPlans'){
          return (
            <SubdomainPlans parent={this} />
          )
        }
        else if(page==='WildcardPlans'){
          return (
            <WildcardPlans parent={this} data={data}/>
          )
        }
        else if(page==='PopularPlans'){
          return (
            <PopularPlans parent={this} data={data}/>
          )
        }
        else if(page==='PremiumPlans'){
          return (
            <PremiumPlans parent={this} data={data}/>
          )
        }
        else if(page==='PersonalPlans'){
          return (
            <PersonalPlans parent={this} data={data}/>
          )
        }
        else if(page==='PersonalSecurePlans'){
          return (
            <PersonalSecurePlans parent={this} data={data}/>
          )
        }
        else if(page==='AcceptingPaymentPlans'){
          return (
            <AcceptingPaymentPlans parent={this} />
          )
        }
        else{
          return (<Start parent={this} />);
        }
      }else{
        return ('');
      }
    }
    return ReactDOM.createPortal(
      <div className={`SSL-Selector ${SSL_SELECTOR_CLASSNAME}__main`}>
        <div className={"SSL-Selector__wrapper clearfix"}>
          <div className={`SSL-Selector__icon`}><img className={`icon__image`} src={searchIcon} alt={`Search`} /> </div>
          <div className={`SSL-Selector__heading clearfix`}>Need help choosing the right SSL Certificate?</div>
          <PageRouter />
        </div>
      </div>
      , container)
  }
}
SSLSelectorConnector.propTypes = {
  container : PropTypes.object,
  pids: PropTypes.string
}

export const RenderSSLSelectorConnector = (props) => {
  const { router } = props
  const ssl = Array.from(document.querySelectorAll(`.${SSL_SELECTOR_CLASSNAME}`))
  if (ssl && ssl.length) {
    return ssl.map((el, index) => {
      const pids = el.getAttribute('data-pids')
      return (<SSLSelectorConnector
        router={router}
        key={index}
        container={el}
        pids={pids}
      />)
    })
  }
  return (<></>)
}

RenderSSLSelectorConnector.propTypes = {
  router: PropTypes.any
}